__turbopack_context__.v({
  "root": "YA45Sq_root",
});
